// Effetti sonori discreti di Willy, sintetizzati con Web Audio (nessun file). Preferenza salvata in localStorage.
const KEY = "es_willy_sound";
let ctx = null;

export const soundEnabled = () => localStorage.getItem(KEY) !== "0";
export const setSoundEnabled = (on) => localStorage.setItem(KEY, on ? "1" : "0");

const ac = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  ctx = ctx || new AC();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
};

const tone = (c, { freq, at = 0, dur = 0.18, type = "sine", gain = 0.05, slideTo }) => {
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, c.currentTime + at);
  if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, c.currentTime + at + dur);
  g.gain.setValueAtTime(0.0001, c.currentTime + at);
  g.gain.exponentialRampToValueAtTime(gain, c.currentTime + at + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + at + dur);
  o.connect(g).connect(c.destination);
  o.start(c.currentTime + at);
  o.stop(c.currentTime + at + dur + 0.02);
};

const play = (fn) => { if (!soundEnabled()) return; const c = ac(); if (c) { try { fn(c); } catch { /* ignore */ } } };

/** "Ding" morbido a due note: Willy ha trovato la risposta. */
export const playFound = () => play((c) => { tone(c, { freq: 880, dur: 0.16, gain: 0.04 }); tone(c, { freq: 1318, at: 0.11, dur: 0.26, gain: 0.035 }); });
/** "Whoosh + pop": Willy lancia il prodotto. */
export const playPresent = () => play((c) => { tone(c, { freq: 220, slideTo: 900, dur: 0.22, type: "triangle", gain: 0.03 }); tone(c, { freq: 1200, at: 0.24, dur: 0.07, type: "square", gain: 0.02 }); });
/** Nota bassa discreta: Willy non è sicuro. */
export const playSorry = () => play((c) => { tone(c, { freq: 440, dur: 0.18, gain: 0.03 }); tone(c, { freq: 330, at: 0.16, dur: 0.26, gain: 0.03 }); });
/** Fruscio di pagina: Willy apre il manuale. */
export const playPage = () => play((c) => { tone(c, { freq: 2400, slideTo: 600, dur: 0.12, type: "triangle", gain: 0.012 }); });
/** Squillo telefonico morbido: Willy chiama l'assistenza. */
export const playRing = () => play((c) => { [0, 0.09, 0.9, 0.99].forEach((at) => tone(c, { freq: 1040, at, dur: 0.07, type: "sine", gain: 0.018 })); });
